import React from "react";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import { Button, Modal } from "react-bootstrap";
import Immutable from "immutable";
import util from "../lib/util.js";

const MenuItem = (props) => {
    let target = props.link.indexOf("http") > -1 ? "_blank" : "";
    return (
        <li>
            <a href={props.link} target={target}>
                <i className={props.iconClass}></i>
                {props.title}
            </a>
        </li>);
};

class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            menuItems: []
        };
    }

    componentWillMount() {
        let self = this;
        ajax.api().get("menus")
            .then((res) => {
                self.setState({
                    menuItems: res.data
                });
            })
            .catch(function (err) {
                console.error("Error: " + err.message);
                self.setState({
                    menuItems: []
                });
            })
    }

    componentDidMount() {
        $("#bodyContent").offCanvasMenu("right");
        $("#mainMobileContainer").offCanvasMenu();
    }

    render() {
        let counter = 1;
        // let items = this.state.menuItems.filter(item => !item.isSensitive).map(item => (
        let items = this.state.menuItems.map(item => (
            item.isSensitive == false ?
                <MenuItem key={`menu_${item.title}_${counter++}`} link={`${context.appRoot()}/${item.href}`} iconClass={item.iconClass} title={item.title} /> :
                <li key={`menu_${item.title}_${counter++}`}>
                    <a href={context.routeUrl('home?sensitiveHref=' + encodeURIComponent(item.href))}>
                        <i className={item.iconClass}></i>
                        {item.title}
                    </a>
                </li>
        ));
        return (
            <aside className="ocm-menu ap-off-canvas-menu">
                <a className="ocm-toggler ap-exit-off-canvas">
                    <img src={context.url("images/close-cross.svg")} />
                </a>
                <ul>
                    {items}
                </ul>
            </aside>
        );
    }
}


class Brand extends React.Component {
    render() {
        return (
            <a href={this.props.rootUrl}>
                <img className="ap-navbar-logo" src={this.props.logoUrl} />
            </a>
        );
    }
}

class MenuToggler extends React.Component {
    render() {
        return (
            <div className="ap-off-canvas-toggler ocm-toggler">
                <a className="right-off-canvas-toggle ap-menu-toggler">
                    <span className="ap-toggler-text">MENU</span>
                    <i className="glyphicon glyphicon-menu-hamburger ap-toggler-hamburger"></i>
                </a>
            </div>
        );
    }
}

class Header extends React.Component {
    render() {
        return (
            <nav className="ap-top-bar">
                <Brand rootUrl={context.routeUrl("home")} logoUrl={context.logoUrl()} />
                {this.props.menuVisibility == 'hide' ? null : <MenuToggler />}
            </nav>
        );
    }
}

class Footer extends React.Component {
    render() {
        return (
            <footer className="hidden-sm hidden-xs">
                <section id="secAssociates">
                    <div>
                        &nbsp;
                    </div>
                </section>
                <section id="secCopyright">
                    <div className="ap-section-copyright">
                        <div id="divCopyright"><p>{context.copyright()}</p></div>
                    </div>
                </section>
            </footer>);
    }
}

export default class App extends React.Component {

    constructor(props) {
        super(props);
        const _c_ = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 66, 65];
        const self = this;

        window.onkeydown = function (evt) {
            /** @type {Array<number>} */
            const __q__ = window.__q__ || (window.__q__ = []);
            __q__.push(evt.keyCode);
            if (__q__.length > 20) __q__.splice(0, 1);
            if (self._cMatch(__q__, _c_)) {
                console.log("C _ e a t - o * e E n a b l e d"
                    .split(' ')
                    .join(''));
            }
        }

        this.onMessage = this.onMessage.bind(this);
        this.onCloseDialog = this.onCloseDialog.bind(this);
        this.state = {
            visible: true,
            dialog: { type: "", icon: "", show: false, title: "", message: "", buttons: "" },
            popupDialog: { type: "", icon: "", show: false, title: "", message: "", buttons: "", size: "md" },
        };


    }

    componentWillMount() {
        context.registerMessageHandler(this.onMessage);
        let curRoute = this.props.routes[this.props.routes.length - 1];
        if (curRoute) ajax.setAjaxRequestRole(curRoute.role || "");
    }

    componentWillUnmount() {
        context.discardMessageHandler();
    }

    componentDidMount() {
        let curRoute = this.props.routes[this.props.routes.length - 1];
        if (curRoute.path === this.props.route.path) {
            window.location = context.routeUrl("home");
        }

    }

    onMessage(msg, callback, state) {
        if (msg.type === "popup") {
            let clone = Immutable.fromJS(this.state).toJS();
            clone.popupDialog.callback = callback;
            clone.popupDialog.state = state;
            clone.popupDialog.type = msg.type;            
            clone.popupDialog.size = msg.size || "md";
            clone.popupDialog.show = msg.show;
            clone.popupDialog.message = msg.message;
            clone.popupDialog.title = msg.title ? msg.title : "";
            this.setState(clone);

        } else {
            let clone = Immutable.fromJS(this.state).toJS();
            clone.dialog.callback = callback;
            clone.dialog.state = state;
            clone.dialog.type = msg.type;

            switch (clone.dialog.type) {
                case "loading": clone.dialog.icon = context.url("images", "preloader.gif"); break;
                case "error": clone.dialog.icon = context.url("images", "error.png"); break;
                case "warning": clone.dialog.icon = context.url("images", "warning.png"); break;
                case "info": clone.dialog.icon = context.url("images", "info.png"); break;
                default: clone.dialog.icon = ""; break;
            }
            clone.dialog.buttons = msg.buttons;

            clone.dialog.show = msg.show;
            clone.dialog.message = msg.message;
            clone.dialog.title = msg.title ? msg.title : "";
            this.setState(clone);
        }
    }

    onCloseDialog(button) {
        let self = this;
        context.message({ show: false });
        if (this.state.dialog.callback) this.state.dialog.callback(button, self.state.dialog.state);
    }

    /**
     * @private
     */
    _cMatch(__q__, __c__) {
        if (__q__.length < __c__.length) return false;
        for (let i = __c__.length - 1, j = __q__.length - 1; i >= 0; i--, j--) {
            if (__q__[j] !== __c__[i]) return false;
        }
        return true;
    }

    render() {
        let curRoute = this.props.routes[this.props.routes.length - 1];
        let menuVisibility = curRoute && curRoute.menuVisibility ? curRoute.menuVisibility : "";

        if (!this.props.children || this.props.children.length == 0) {
            window.location = context.routeUrl("home");
        }

        let indexUrl = context.routeUrl("home");
        let logoUrl = context.logoUrl();

        let dialogHeader = this.state.dialog.title !== "" ?
            <Modal.Header closeButton={false}>
                <Modal.Title>
                    {this.state.dialog.title}
                </Modal.Title>
            </Modal.Header> : null;

        let popupHeader = this.state.popupDialog.title !== "" ?
            <Modal.Header closeButton={false}>
                <Modal.Title>
                    {this.state.popupDialog.title}
                </Modal.Title>
            </Modal.Header> : null;

        let dialogFooter = this.state.dialog.buttons && this.state.dialog.buttons.length > 0 ?
            (
                <Modal.Footer>
                    <Button className={this.state.dialog.buttons.includes("close") ? "" : "ap-hidden"} onClick={() => this.onCloseDialog("close")}>Close</Button>
                    <Button className={this.state.dialog.buttons.includes("ok") ? "" : "ap-hidden"} onClick={() => this.onCloseDialog("ok")}>OK</Button>
                    <Button className={this.state.dialog.buttons.includes("yes") ? "" : "ap-hidden"} onClick={() => this.onCloseDialog("yes")}>Yes</Button>
                    <Button className={this.state.dialog.buttons.includes("continue") ? "" : "ap-hidden"} onClick={() => this.onCloseDialog("continue")}>Continue</Button>
                    <Button className={this.state.dialog.buttons.includes("no") ? "" : "ap-hidden"} onClick={() => this.onCloseDialog("no")}>No</Button>
                    <Button className={this.state.dialog.buttons.includes("cancel") ? "" : "ap-hidden"} onClick={() => this.onCloseDialog("cancel")}>Cancel</Button>
                </Modal.Footer>) : null;
        let icon = (<img className="ap-dialog-icon" src={this.state.dialog.icon} />);

        return (
            <div id="bodyContent" style={{ display: this.state.visible ? "block" : "none", height: "100%" }}>
                <div id="mainContainer" style={{ display: "flex", flexDirection: "column", height: util.isIE() ? "auto" : "100%" }}>
                    <div className="ap-primary" style={{ flexGrow: 0 }}>
                        <Header menuVisibility={menuVisibility} />
                    </div>
                    <div className="container-fluid body-content" style={{ padding: '0px', flexGrow: 1 }}>
                        {this.props.children}
                    </div>
                    <div style={{ flexGrow: 0 }}>
                        <Footer />
                    </div>

                </div>
                {menuVisibility == 'hide' ? null : <Menu />}
                <Modal show={this.state.dialog.show}>
                    {dialogHeader}
                    <Modal.Body className="ap-dialog-body">
                        <div className="container-fluid">
                            {
                                this.state.dialog.icon ?
                                    <div className="row">
                                        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                            {this.state.dialog.icon && this.state.dialog.icon.trim().length > 0 ? icon : null}
                                        </div>
                                        <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">{this.state.dialog.message}</div>
                                    </div> :
                                    <div className="row">
                                        <div className="col-md-12">{this.state.dialog.message}</div>
                                    </div>
                            }
                        </div>
                        {dialogFooter}
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.popupDialog.show} bsSize={this.state.popupDialog.size} data-keyboard={false}>
                    {popupHeader}
                    <Modal.Body className="ap-dialog-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">{this.state.popupDialog.message}</div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

            </div>
        );
    }
}
